module.exports = __webpack_public_path__ + "img/reset-key-fill.ba799e5b.svg";